import type { InputStatus } from 'antd/lib/_util/statusUtils';
import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

export const getBorderStyle = (status?: InputStatus): FlattenInterpolation<ThemeProps<DefaultTheme>> => {
  switch (status) {
    case 'warning':
      return css`
        border-radius: 2px;
        border: 1px solid ${({ theme }) => theme.color.status.severeWarning};
        box-shadow: none;

        :hover {
          border-color: ${({ theme }) => theme.color.status.severeWarning};
        }

        :focus,
        :focus-within {
          /* NOTE: Ant distinguishes between hovered/not hovered focus
          this color was derived from theme.color.status.error like ant does it color(~\`colorPalette('@{warning-color}', 5) \`); */
          border-color: #ffc35c;
          box-shadow: 0 0 0 2px ${({ theme }) => theme.color.status.severeWarning}33;

          :hover {
            border-color: ${({ theme }) => theme.color.status.severeWarning};
          }
        }
      `;
    case 'error':
      return css`
        border-radius: 2px;
        border: 1px solid ${({ theme }) => theme.color.status.error};
        box-shadow: none;

        :hover {
          border-color: ${({ theme }) => theme.color.status.error};
        }

        :focus,
        :focus-within {
          /* NOTE: Ant distinguishes between hovered/not hovered focus
          this color was derived from theme.color.status.error like ant does it color(~\`colorPalette('@{error-color}', 5) \`); */
          border-color: #ff8987;
          box-shadow: 0 0 0 2px ${({ theme }) => theme.color.status.error}33;

          :hover {
            border-color: ${({ theme }) => theme.color.status.error};
          }
        }
      `;
    default:
      return css`
        border-radius: 2px;
        box-shadow: none;

        :hover {
          border-color: ${({ theme }) => theme.color.grey.grey11};
        }

        :focus,
        :focus-within {
          /* NOTE: Ant distinguishes between hovered/not hovered focus
          this color was derived from themePrimary like ant does it color(~\`colorPalette('@{primary-color}', 5) \`); */
          border-color: #3ab0a6;
          box-shadow: 0 0 0 2px ${({ theme }) => theme.color.theme.primary}33;

          :hover {
            border-color: ${({ theme }) => theme.color.theme.primary};
          }
        }
      `;
  }
};
